<template>
  <div id="app" >
    <pcHeaderNew ></pcHeaderNew>
    <div class="content-block" >
      <router-view :key="$route.fullPath"></router-view>
    </div>
    <pcFooterNew ></pcFooterNew>
  </div>
</template>

<script>

import pcHeaderNew from "./components/header/headerNew.pc.vue";
import pcFooterNew from "./components/footer/footerNew.pc";

export default {
  name: "app",
  components: {
    pcFooterNew,
    pcHeaderNew,
  },
  computed: {
  },
  mouted(){
    debugger
     var language = localStorage.getItem("sys-locale");
    if (!language) {
      language = "zh-CN";
    } else if (language.includes("CN")) {
      language = "zh-CN";
    } else if (language.includes("en") || language.includes("US")) {
      language = "en-US";
    } else if (language.includes("TW") || language.includes("HK")) {
      language = "zh-HK";
    } else if (language.includes("ja") || language.includes("JP")) {
      language = "ja-JP";
    } else if (language.includes("ko") || language.includes("KR")) {
      language = "ko-KR";
    } else if (language.includes("jd") || language.includes("JD")) {
      language = "id-ID";
    } else {
      language = "en-US";
    }
    this.$i18n.locale = language;
  }
};
</script>
<style>
html,
body {
  width: 100%;
  /* background: #232323; */
}
</style>
<style lang="scss" scoped>
.content-block {
  width: 100%;
  height: 100%;
  margin: auto;
  //min-height: calc(100vh - 79px);
}
.min-bg {
   min-width: 1200px;
   width: 100%;
  
}
.h-light {
  color: #d9a73a;
}
.lose-connection {
  position: fixed;
  z-index: -1;
  left: 20px;
  right: 20px;
  top: 200px;
  text-align: center;
  background-color: rgba(222, 177, 66, 0.64);
  line-height: 100px;
  font-size: 24px;
  color: #ffffff;
  border-radius: 2px;
  opacity: 0;
  transform: translateY(-200px);
  transition: transform 0.3s;
  &.active {
    z-index: 3;
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
